<form [formGroup]="trophyForm" class="example-form w-100 mb-2" style="height:auto; overflow-y: auto;" >
    <mat-form-field class="w-100">
        <mat-label>{{'FORM.trophyForm.tagID' | translate}}</mat-label>
        <input formControlName="tagID" matInput type="text">
    </mat-form-field>    
    <mat-form-field class="w-100">
        <mat-label>{{'FORM.trophyForm.type' | translate}}</mat-label>
        <mat-select formControlName="trophyType" required>
            <mat-option *ngFor="let type of dropDownTrophyTypes" [value]="type">
                <!-- <img [src]="'assets/icons/'+data.iconName+'.svg'" alt=""> -->
                {{type.title}}
            </mat-option>
        </mat-select>
        <mat-error *ngIf="trophyForm.controls.trophyType.errors?.required">
            {{ 'FORM_VALIDATION.REQUIRED' | translate }}
        </mat-error>
    </mat-form-field>
    <mat-form-field class="w-100">
        <mat-label>{{'FORM.trophyForm.comment' | translate}}</mat-label>
        <textarea formControlName="comment" matInput type="text"></textarea>
    </mat-form-field>
</form>

<div class="sticky-bottom">
    <button [disabled]="trophyForm.invalid" class="first-btn w-100 my-1" mat-raised-button type="submit" (click)="onSubmit()">
        {{ 'FORM.BTN_SAVE' | translate }}
    </button>

    <button [disabled]="trophyForm.invalid" class="second-btn w-100 my-1" mat-button type="button" (click)="onDelete()">
        {{ 'FORM.BTN_DELETE' | translate }}
    </button>
</div>